import * as React from "react";
import Modal from "../../ui/modal/Modal";
import JobStatus from "../../../model/job/JobStatus";
import EditJobStatusForm from "../form/edit/EditJobStatusForm";

interface IComponentProps {
	/**
	 * On successful edited job status callback.
	 */
	onSuccess: () => void;
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
	/**
	 * Job status to edit
	 */
	editedJobStatus: JobStatus;
}

export default class EditJobStatusModal extends React.Component<IComponentProps, {}> {
	render() {
		return (
			<Modal onCloseClicked={this.props.onCancel} title={"Edit Job Status"}>
				<EditJobStatusForm onSuccess={this.props.onSuccess} onCancel={this.props.onCancel} editedJobStatus={this.props.editedJobStatus}/>
			</Modal>
		);
	}
}
